// extracted by mini-css-extract-plugin
export default {"search_info":"search-info_search_info__myjNC","location":"search-info_location__ZC7GX","text":"search-info_text__Ds5LX","date":"search-info_date__d6xNZ"};